import { Helmet } from 'react-helmet-async';
import Enrichment from '../modules/enrichment/Enrichment';

export default function EnrichmentPage() {
  return (
    <>
      <Helmet>
        <title>DISGENET: Enrichment Analysis</title>
        <meta name="description" content="Perform enrichment analysis with DISGENET." />
      </Helmet>
      <div className="advanced-research container-view md:p-4">
        <div className="search-results-container">
          <Enrichment />
        </div>
      </div>
    </>
  );
}
